export default "/kiban/_next/static/images/white-ee63d6235453116cc5bc53d7c10a791a.png";